<template>
  <div
    v-if="value.source && value.type"
    ref="Step4"
    tabindex="-1"
    class="focus:outline-none focus:border-none"
    @keydown.enter="$emit(Events.SUBMIT)"
  >
    <h1 class="mb-4 font-mono text-xxs uppercase tracking-wider">
      Summary:
    </h1>
    <div class="md:mx-4 p-4 text-gray-700 border">
      <lm-title class="mb-3">{{ value.title }}</lm-title>
      <div class="flex items-center mb-3">
        <lm-icon
          :icon="value.type.toLowerCase()"
          class="text-gray-700 flex-shrink-0"
          size="21"
        />
        <span class="ml-2 text-xs text-gray-700">{{
          FeedSourcesLabels[value.type]
        }}</span>
        <template v-if="showUrl">
          <span
            class="flex items-center ml-4 mr-1 text-xs text-gray-500 italic truncate"
          >
            {{ value.source }}
          </span>
          <lm-icon-button
            svg-size="16"
            icon="openInNew"
            tooltip="Open in a new tab"
            svg
            @click.prevent="openLink"
          />
        </template>
      </div>
      <div class="flex items-center mb-3">
        <lm-actor-circle :color="actor.color" class="mr-2" />
        <span class="text-xs"> {{ actor.name }}</span>
      </div>
      <p v-if="value.description" class="mb-3 text-gray-700">
        {{ value.description }}
      </p>
      <ul v-if="value.tags && value.tags.length > 0" class="flex mt-4">
        <li
          v-for="tag in value.tags"
          :key="tag"
          class="mr-2 py-1 px-2 border border-gray-300 bg-gray-200 text-xs text-gray-500"
        >
          {{ tag }}
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import LmIcon from '@/components/ui/LmIcon'
import LmIconButton from '@/components/ui/LmIconButton'
import LmActorCircle from '@/components/ui/misc/LmActorCircle'
import LmTitle from '@/components/ui/text/LmTitle'
import {Events, FeedSources, FeedSourcesLabels} from '@/lib/definitions'
import {mapGetters} from 'vuex'
const SHOW_URL_FEED_TYPES = [
  FeedSources.RSS,
  FeedSources.TWITTER,
  FeedSources.YOUTUBE,
  FeedSources.VIMEO,
  FeedSources.NEWSLETTER,
  FeedSources.MEDIUM,
  FeedSources.SLIDESHARE,
  FeedSources.REDDIT
]

export default {
  name: 'FeedSourceStep4',
  components: {
    LmTitle,
    LmActorCircle,
    LmIconButton,
    LmIcon
  },
  props: {
    value: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      Events,
      FeedSourcesLabels
    }
  },
  computed: {
    ...mapGetters(['getActorByID']),
    showUrl() {
      return SHOW_URL_FEED_TYPES.includes(this.value.type)
    },
    actor() {
      return this.getActorByID(this.value.actorId)
    }
  },
  mounted() {},
  methods: {
    async init() {
      await this.$nextTick()
      this.$refs.Step4.focus() // native
    },
    openLink() {
      window.open(this.value.url, '_blank')
    },
    validate() {
      return true
    },
    clear() {
      // Public. Do not remove!!
    }
  }
}
</script>

<style scoped></style>
